import styles from "./CourseSkeleton.module.scss";

export const CourseSkeleton = () => {
  return (
    <>
      <div className={styles.top}>
        <div className={styles.title}></div>
      </div>
      <div className={styles.block}>
        <div className={styles.small}> </div>
        <div className={styles.small}></div>
        <div className={styles.small}></div>
      </div>
      <div className={styles.block}>
        <div className={styles.big}> </div>
      </div>
      <div className={styles.block}>
        <div className={styles.big}> </div>
        <div className={styles.small}></div>
        <div className={styles.small}></div>
        <div className={styles.divider}></div>
        <div className={styles.big}></div>
        <div className={styles.small}></div>
        <div className={styles.small}></div>
      </div>
      <div className={styles.block}>
        <div className={styles.small}> </div>
        <div className={styles.small}></div>
        <div className={styles.small}></div>
      </div>
      <div className={styles.block}>
        <div className={styles.big}> </div>
      </div>
      <div className={styles.block}>
        <div className={styles.small}> </div>
        <div className={styles.small}></div>
        <div className={styles.small}></div>
      </div>
      <div className={styles.block}>
        <div className={styles.small}> </div>
        <div className={styles.small}></div>
        <div className={styles.small}></div>
      </div>
      <div className={styles.link}> </div>
    </>
  );
};
